import { defineStore } from 'pinia'
import type Lenis from 'lenis'

export interface StoreLenisState {
  lenis: Lenis | null
}

export const useLenisStore = defineStore('LenisStore', {
  state: (): StoreLenisState => {
    return {
      lenis: null
    }
  }
})
